// src/features/commands/useCooldownOverrides.ts
// cooldownOverrides lives in guilds.settings (not command_overrides,
// which only covers enabled/custom_response) — same PATCH endpoint
// ChannelsPage/SettingsPage use, just a different key within it.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export function useUpdateCooldownOverrides(guildId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (cooldownOverrides: Record<string, number>) =>
      apiFetch(`/api/guilds/${guildId}`, {
        method: 'PATCH',
        body: JSON.stringify({ settings: { cooldownOverrides } }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['guilds'] }),
  });
}
